import Vue from 'vue'

const state = {
	active: false,

  // values
  preset: {
    type: 'layoutImage',
    uuid: null,
    posX: 0,
    posY: 0,
    width: 100,
    height: 100,
    zIndex: 0
  },
	values: {},
  
  // 設定モード
  isModify: false
}

const getters = {
	get: state => state
}

const actions = {
  show ({commit}, data) {
    let isModify = data ? true : false
    if (isModify) {
      commit('setValues', $.extend(true, {}, data))
    } else {
      commit('setValues', $.extend(true, {}, state.preset))
    }

    // cover
    this.dispatch('core/showSclCover')
    // show
    commit('showed', isModify)
  },
  hide ({commit}) {
    if (!state.active) return
    // hide
    commit('hided')
    // cover
    setTimeout(() => {
      this.dispatch('core/hideSclCover')
    }, 350)
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  showed (state, isModify) {
    state.isModify = isModify
    state.active = true
  },
  hided (state) {
    state.active = false
  },

  // form
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {keys, value}) {
    if (keys.length === 2) {
      Vue.set(state.values[keys[0]], keys[1], value)
    } else {
      Vue.set(state.values, keys[0], value)
    }
  },

  // reset
  reset (state) {
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
